import { useRef } from 'react'

// AI-CONTEXT: See docs/features/dashboard-empty-states.md
//
// Soft, greyed-out "ghost chart" that sits behind the empty-state content.
// Design variant A+D: a rising trend curve rendered as a blurred bloom so the
// card still reads as a chart card while clearly having no real data.

// React 17 has no useId(); a module-level counter gives each instance a
// stable, collision-free suffix for its gradient/filter ids.
let bloomCounter = 0

/**
 * Decorative background for DashboardCardEmptyState. Purely visual.
 */
const EmptyStateBloom = () => {
    const rawId = useRef(`b${(bloomCounter += 1)}`).current
    const curve = 'M0,300 C90,288 150,250 230,210 C300,176 360,120 440,72'
    const area = `${curve} L440,360 L0,360 Z`

    return (
        <svg
            className='dashboard-empty-state-viz'
            viewBox='0 0 440 360'
            preserveAspectRatio='none'
            aria-hidden='true'
        >
            <defs>
                <linearGradient id={`des-fill-${rawId}`} x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='0%' stopColor='#d2d7dc' stopOpacity='0.34' />
                    <stop offset='55%' stopColor='#d2d7dc' stopOpacity='0.10' />
                    <stop offset='100%' stopColor='#d2d7dc' stopOpacity='0' />
                </linearGradient>
                <filter id={`des-blur-${rawId}`} x='-20%' y='-20%' width='140%' height='140%'>
                    <feGaussianBlur stdDeviation='7' />
                </filter>
            </defs>
            <path
                d={curve}
                fill='none'
                stroke='#cdd2d8'
                strokeWidth='6'
                strokeLinecap='round'
                opacity='0.4'
                filter={`url(#des-blur-${rawId})`}
            />
            <path d={area} fill={`url(#des-fill-${rawId})`} filter={`url(#des-blur-${rawId})`} />
        </svg>
    )
}

export default EmptyStateBloom
